import { useTranslation } from 'react-i18next';

import { Badge } from '@saas-kit/ui';

export function PlanStatusBadge({ active }: { active: boolean }): JSX.Element {
  const { t } = useTranslation('adminPlans');
  return (
    <Badge variant={active ? 'success' : 'outline'}>
      {t(active ? 'status.active' : 'status.archived')}
    </Badge>
  );
}
